export default {"id":"efda60a7","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}